import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AuthActions } from "@ha/feature/auth";
import { BaseModalComponent } from "@ha/ui/common";
import { Store } from "@ngxs/store";

@Component({
    templateUrl: "./must-enable-mfa.component.html",
    styleUrls: ["./must-enable-mfa.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MustEnableMfaComponent extends BaseModalComponent {
    constructor(private store: Store) {
        super();
    }

    public logout(): void {
        this.store.dispatch(new AuthActions.SignOut());
    }
}
